import * as React from 'react';

import { VideoLibrary2 as VideoLibrarySVG } from '@bblabs/module-library/svgs';
import { ParentTabProps, Tab, TabProps } from './Tab';

export const VideoLibraryTab = (props: ParentTabProps) => {
  const name = 'Videos';
  const icon = <VideoLibrarySVG title={name} size={`${16.75 / 2.31}`} fill="#a0a0a0" />;
  const propsForTab: TabProps = {
    activeTab: props.activeTab,
    cssClass: 'tab--video-library',
    id: 'video-library',
    onClick: props.onSelect,
    name,
    icon,
  };
  return <Tab key={name} {...propsForTab} />;
};
